import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class CommentButtonModel extends ButtonBase {
    label: string = 'Comment';
    action: string = ACTION_STATUS.comment;
    matIconName: string = 'comment';
    colorClass: string = 'color-info-500';
}